/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext } from "react";
import { MyContext } from "../../Context/MyProvider";
import { IoCall } from "react-icons/io5";

const MiroTalkCallView = ({ Data, LeaveCall, userId }) => {
    const { videoCallConfig } = useContext(MyContext);
    
    // Create unique room name
    const roomId = Data?.appointment_id || `${userId}_${Data?.doctor_id}`;
    const serverUrl = videoCallConfig?.mirotalk_server_url || "https://meet.mirotalk.com";
    const mirotalkUrl = `${serverUrl}/join/${roomId}`;

    return (
        <div className="flex flex-col h-[100%] justify-between relative bg-slate-955 rounded-xl overflow-hidden shadow-2xl border border-slate-800">
            <div className="flex-1 relative w-full h-[430px] bg-slate-900">
                <iframe
                    src={mirotalkUrl}
                    allow="camera; microphone; fullscreen; display-capture; autoplay"
                    className="w-full h-full border-none rounded-t-xl"
                    title="MiroTalk Call Room"
                />
            </div>
            
            {/* Control Bar with decline/leave call button */}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center z-50">
                <button 
                    className="p-3 bg-red-650 hover:bg-red-500 rounded-full text-white transition-all shadow-xl border border-transparent hover:scale-105" 
                    onClick={LeaveCall}
                >
                    <IoCall size={18} />
                </button>
            </div>
        </div>
    );
};

export default MiroTalkCallView;
/* jshint ignore:end */
